export interface CanvasDragEvent {
  canvas: any;
  figure: any;
  eventType: CanvasDragEventType;
}

export enum CanvasDragEventType {
  DRAG, DRAG_END
}
